import React from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import asyncComponent from '../../util/asyncComponent';

import CobrancaRoutes from './routes/CobrancaRoutes';
import CadastroRoutes from './routes/CadastroRoutes';
import FinanceiroRoutes from './routes/FinanceiroRoutes';
import BackofficeRoutes from './routes/BackofficeRoutes';
import ComercialRoutes from './routes/ComercialRoutes';
import DashboardRoutes from './routes/DashboardRoutes';
import DigitalRoutes from './routes/DigitalRoutes';
import RelatorioRoutes from './routes/RelatorioRoutes';
import ConfigRoutes from './routes/ConfigRoutes';

const erro404 = asyncComponent(() =>
  import('app/routes/extraPages/routes/404')
);
const erro401 = asyncComponent(() =>
  import('app/routes/extraPages/routes/401')
);

const Routes = ({ match }) => (
  <Switch>
    <Route
      path={`${match.url}/cob`}
      render={() => <CobrancaRoutes match={match} />}
    />
    <Route
      path={`${match.url}/cad`}
      render={() => <CadastroRoutes match={match} />}
    />
    <Route
      path={`${match.url}/fin`}
      render={() => <FinanceiroRoutes match={match} />}
    />
    <Route
      path={`${match.url}/backof`}
      render={() => <BackofficeRoutes match={match} />}
    />
    <Route
      path={`${match.url}/com`}
      render={() => <ComercialRoutes match={match} />}
    />
    <Route
      path={`${match.url}/dash`}
      render={() => <DashboardRoutes match={match} />}
    />
    <Route
      path={`${match.url}/digital`}
      render={() => <DigitalRoutes match={match} />}
    />
    <Route
      path={`${match.url}/rel`}
      render={() => <RelatorioRoutes match={match} />}
    />
    <Route
      path={`${match.url}/config`}
      render={() => <ConfigRoutes match={match} />}
    />

    <Route path={`${match.url}/acesso-negado`} component={erro401} />
    <Route component={erro404} />
  </Switch>
);

export default withRouter(Routes);
